export default __webpack_public_path__ + "static/media/setting_active.76167558.svg";